export const GET_EXPENSES_QUERY = `
  query GetExpenses($where: expense_requests_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [expense_requests_order_by!] = [{ id: desc }]) {
    expense_requests_aggregate(where: $where) {
      aggregate { count }
    }
    expense_requests(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      expense_type_id
      company_id
      user_id
      status
      reject_reason
      expense_date
      amount
      description
      paid_amount
      approving_manager_id
      approving_date
      created_at
      updated_at
      expense_type {
        expense_type_name
      }
      user {
        first_name
        last_name
        team {
          id
          name
          group {
            id
            name
          }
        }
        company {
          id
          name
        }
      }
      approving_manager {
        first_name
        last_name
      }
    }
  }
`; 